module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "gPageBorder"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (this.editInfo.status === 3),
      expression: "this.editInfo.status === 3"
    }]
  }, [_c('el-alert', {
    staticStyle: {
      "display": "-webkit-flex",
      "margin": "0 0 24px 0"
    },
    attrs: {
      "title": _vm.reason,
      "type": "error",
      "show-icon": ""
    }
  })], 1), _vm._v(" "), _c('el-form', {
    ref: "addForm",
    staticClass: "gForm",
    attrs: {
      "id": "addForm",
      "model": _vm.form,
      "rules": _vm.rules,
      "label-width": "13.5%"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('app_ad') + _vm.$t('app_name'),
      "prop": "videoName"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": _vm.$t('app_input')
    },
    model: {
      value: (_vm.form.videoName),
      callback: function($$v) {
        _vm.$set(_vm.form, "videoName", $$v)
      },
      expression: "form.videoName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (true),
      expression: "true"
    }],
    attrs: {
      "label": _vm.$t('app_vdofile'),
      "prop": "url"
    }
  }, [_c('el-upload', {
    staticClass: "upload-demo aeMg",
    attrs: {
      "data": _vm.uData,
      "drag": "",
      "name": "fileUpload",
      "file-list": _vm.fileList,
      "on-success": _vm.fileUploadSuccess,
      "before-upload": _vm.fileBeforeUpload,
      "action": _vm.$videoUrl
    }
  }, [_c('span', [(_vm.ulinfo.index === 0) ? _c('i', {
    class: _vm.ulinfo.icons[_vm.ulinfo.index]
  }) : _c('div', {
    staticStyle: {
      "margin-top": "12px",
      "color": "#48576A"
    }
  }, [_c('i', {
    class: _vm.ulinfo.icons[_vm.ulinfo.index],
    style: (_vm.tipColor)
  }), _vm._v(" "), _c('el-col', [_c('el-row', {
    staticStyle: {
      "margin-top": "-8px"
    }
  }, [_c('div'), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "26px"
    }
  }, [_vm._v(_vm._s(_vm.$t('app_filename')) + ": " + _vm._s(_vm.form.fileName))]), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "26px"
    }
  }, [_vm._v(_vm._s(_vm.$t('app_vdodur')) + ": " + _vm._s(_vm.form.duration))]), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "26px"
    }
  }, [_vm._v(_vm._s(_vm.$t('app_fileSize')) + ": " + _vm._s(_vm.form.size))]), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "26px"
    }
  }, [_vm._v(_vm._s(_vm.$t('app_vsize')) + ": " + _vm._s(_vm.form.dimension))]), _vm._v(" "), _c('div', [_c('label', {
    staticStyle: {
      "margin-top": "6px",
      "color": "#B2BBC5",
      "font-size": "12px"
    }
  }, [_vm._v(_vm._s(_vm.$t('app_clreulvdo')))])])])], 1)], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.ulinfo.index === 0),
      expression: "ulinfo.index === 0"
    }],
    staticClass: "el-upload__text"
  }, [_vm._v(_vm._s(_vm.ulinfo.tip))])])])], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": ""
    },
    on: {
      "click": function($event) {
        _vm.$router.go(-1)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('app_cancel')))]), _vm._v(" "), (_vm.isUpload) ? _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.onSubmit
    }
  }, [_vm._v(_vm._s(_vm.$t('app_addvdoad')))]) : _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.onSubmit
    }
  }, [_vm._v(_vm._s(_vm.$t('app_edvdoad')))])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a676c9ca"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/advert/video/defaultEdit.vue
// module id = 1110
// module chunks = 0